import * as React from "react";
import { useState } from "react";
import styled, { css } from "styled-components";
import Routes from "security-app/routing/Routes";
import { BootstrapModalConfirm, MenuItem, DeleteMenuItem, Button } from "components/bootstrap";
import { useArchiveInvestigation, useDeleteInvestigation } from "security-app/hooks/useInvestigationsAPI";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
import { TELEMETRY_EVENT_TYPE } from "telemetry/Constants";
import useLocation from "routing/useLocation";
import useIsInvestigationAIReportEnabled from "security-app/components/Investigations/AIReport/hooks/useIsInvestigationAIReportEnabled";
import AIReportButton from "security-app/components/Investigations/AIReport/AIReportButton";
import { MoreActionsMenu } from "components/common/MoreActions";
import useInvestigationPanel from "./hooks/useInvestigationPanel";
const Wrapper = styled.div(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: ${theme.spacings.xs};
  `
);
function RowActionMenu({
  investigation,
  onDelete: onDeleteProp = void 0,
  onArchive: onArchiveProp = void 0
}) {
  var _a;
  const { openInvestigation } = useInvestigationPanel();
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const isAIReportFeatureEnabled = useIsInvestigationAIReportEnabled();
  const { archiveInvestigation } = useArchiveInvestigation();
  const { deleteInvestigation } = useDeleteInvestigation();
  const { selectedInvestigationId, closeInvestigation, setSelectedInvestigationId } = useInvestigationPanel();
  const sendTelemetry = useSendTelemetry();
  const onArchive = async () => {
    sendTelemetry(TELEMETRY_EVENT_TYPE.SECURITY_APP.INVESTIGATION_ARCHIVED, {
      app_pathname: "security",
      app_section: "investigation"
    });
    await archiveInvestigation({ invId: investigation.id, archive: true });
    if (typeof onArchiveProp === "function") {
      onArchiveProp(investigation.id);
    }
  };
  const onEdit = () => {
    sendTelemetry(TELEMETRY_EVENT_TYPE.SECURITY_APP.INVESTIGATION_EDITED, {
      app_pathname: "security",
      app_section: "investigation"
    });
  };
  const onRestore = async () => {
    sendTelemetry(TELEMETRY_EVENT_TYPE.SECURITY_APP.INVESTIGATION_RESTORED, {
      app_pathname: "security",
      app_section: "investigation"
    });
    await archiveInvestigation({ invId: investigation.id, archive: false });
  };
  const onDelete = async () => {
    sendTelemetry(TELEMETRY_EVENT_TYPE.SECURITY_APP.INVESTIGATION_DELETED, {
      app_pathname: "security",
      app_section: "investigation"
    });
    if (investigation.id === selectedInvestigationId) {
      closeInvestigation();
    }
    await deleteInvestigation({ invId: investigation.id });
    const currentInvestigationId = localStorage.getItem("currentInvestigationId");
    if (currentInvestigationId === investigation.id) localStorage.removeItem("currentInvestigationId");
    if (typeof onDeleteProp === "function") {
      onDeleteProp(investigation.id);
    }
    setShowDeleteModal(false);
  };
  const { pathname } = useLocation();
  const isArchived = pathname.endsWith("investigations/archived");
  return /* @__PURE__ */ React.createElement(Wrapper, null, isAIReportFeatureEnabled && /* @__PURE__ */ React.createElement(AIReportButton, { investigation, logsCount: (_a = investigation == null ? void 0 : investigation.evidence_counts) == null ? void 0 : _a.logs }), /* @__PURE__ */ React.createElement(
    Button,
    {
      onClick: () => openInvestigation(investigation.id),
      title: `Open investigation ${investigation.name} in drawer`
    },
    "Open Drawer"
  ), /* @__PURE__ */ React.createElement(MoreActionsMenu, { title: "Toggle investigation actions" }, isArchived ? /* @__PURE__ */ React.createElement(MenuItem, { onClick: onRestore }, "Restore") : /* @__PURE__ */ React.createElement(React.Fragment, null, investigation.id !== selectedInvestigationId && /* @__PURE__ */ React.createElement(MenuItem, { onClick: () => setSelectedInvestigationId(investigation.id, true) }, "Set as active"), /* @__PURE__ */ React.createElement(MenuItem, { onClick: onArchive }, "Archive"), /* @__PURE__ */ React.createElement(MenuItem, { onClick: onEdit, href: Routes.INVESTIGATIONS.details(investigation.id) }, "Edit"), /* @__PURE__ */ React.createElement(MenuItem, { divider: true }), /* @__PURE__ */ React.createElement(DeleteMenuItem, { onClick: () => setShowDeleteModal(true) }))), /* @__PURE__ */ React.createElement(
    BootstrapModalConfirm,
    {
      title: "Are you sure you want to delete this investigation?",
      onConfirm: onDelete,
      onCancel: () => setShowDeleteModal(false),
      showModal: showDeleteModal
    },
    /* @__PURE__ */ React.createElement("div", null, "You are about to delete this investigation: ", investigation.name)
  ));
}
export default RowActionMenu;
